import React from "react";
import { Link } from "react-router-dom";

const MegaMenu = () => {
  return (
    <ul className="navbar-nav">
      <li className="nav-item active">
        <Link to="/" className="nav-link">
          Home
        </Link>
      </li>
      {/* End li */}

      <li className="nav-item">
        <Link to="/login" className="nav-link">
          Login
        </Link>
      </li>
      {/* End li */}

      <li className="nav-item">
        <Link to="/signup" className="nav-link">
          Sign Up
        </Link>
      </li>
      {/* End li */}

      <li className="nav-item">
        <Link to="/terms-conditions" className="nav-link">
          Terms & Conditions
        </Link>
      </li>
      {/* End li */}
    </ul>
  );
};

export default MegaMenu;
